import { usePwaInstallContext } from '../../context/PwaInstallContext'
import styles from './PwaInstallButton.module.css'

type InstallHintType = NonNullable<
  ReturnType<typeof usePwaInstallContext>['hintType']
>

function InstallHintModal({
  type,
  onClose,
}: {
  type: InstallHintType
  onClose: () => void
}) {
  const content = {
    ios: {
      title: 'Установить Alex на iPhone',
      intro:
        'На iPhone установка делается через Safari. Включите режим приложения:',
      steps: [
        'Safari → «Поделиться» (квадрат со стрелкой)',
        '«На экран Домой» → «Добавить»',
        'Включите «Открывать как веб-приложение» — без этого будет обычная закладка',
        'Готово: Alex откроется без панели Safari',
      ],
    },
    android: {
      title: 'Как установить Alex',
      intro:
        'Установка через Google Chrome. Выберите пункт в меню браузера:',
      steps: [
        'Нажмите ⋮ (три точки) в правом верхнем углу',
        'Выберите «Установить и создать ярлык»',
        'Подтвердите установку',
        'Откройте Alex с рабочего стола. Если нет адресной строки — установилось как приложение',
        'Если открывается браузер: удалите ярлык, в ⋮ → «Информация о сайте» → «Очистить данные», обновите страницу и повторите',
      ],
    },
    'android-not-ready': {
      title: 'Подождите загрузку',
      intro: 'Страница ещё загружается. Подождите несколько секунд и нажмите «Скачать» снова.',
      steps: [
        'Дождитесь полной загрузки страницы',
        'Если страница перезагрузилась — это нормально',
        'Снова нажмите «Скачать приложение»',
      ],
    },
    insecure: {
      title: 'Установка недоступна',
      intro: 'PWA можно установить только по HTTPS.',
      steps: [
        'Откройте сайт по защищённому адресу (https://...)',
        'На localhost установка тоже работает для разработки',
      ],
    },
    'already-installed': {
      title: 'Alex уже установлен',
      intro:
        'Приложение уже добавлено на ваш компьютер или телефон. В обычной вкладке браузера повторная установка недоступна.',
      steps: [
        'Откройте Alex через меню «Пуск» (Windows) или Launchpad (Mac)',
        'Или найдите ярлык Alex на рабочем столе',
        'Чтобы установить заново, сначала удалите приложение в системе',
      ],
    },
  }[type]

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(event) => event.stopPropagation()}>
        <h3 className={styles.modalTitle}>{content.title}</h3>
        <p className={styles.modalText}>{content.intro}</p>
        <ol className={styles.modalList}>
          {content.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        <button type="button" className={styles.modalClose} onClick={onClose}>
          Понятно
        </button>
      </div>
    </div>
  )
}

export function PwaInstallHintModal() {
  const { hintType, closeHint } = usePwaInstallContext()

  if (!hintType) {
    return null
  }

  return <InstallHintModal type={hintType} onClose={closeHint} />
}
